import React, { Component } from "react";

class Home extends Component {
  render() {
    return (
      <div className="home-comp comp" id="home">
        <h1 className="home-title">NISHANT TILVE</h1>
        <h3 className="home-subtitle">
          React/Node Wizard <span role="img">🧙</span>
        </h3>
      </div>
    );
  }
}

export default Home;
